import React, { Component } from "react";

class BuyXGetYItem extends Component{
    
    constructor(props){
        super(props);
        this.state = {
            showDeleteConfirmation: false
        }
    }

    componentDidMount() {
		document.addEventListener("mousedown", this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
	}

	setWrapperRef = (node) => {
		this.wrapperRef = node;
	}

	handleClickOutside = (event) => {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.setState({
				showDeleteConfirmation: false
			});
		}
	}

    deleteBtnClick = () => {
        this.setState({
            showDeleteConfirmation: true
        })
    }

    deleteConfirmBtnYes = () => {
        this.deleteCofirmBtnCancel();
        this.props.deleteItem(this.props.index);
    }

    deleteCofirmBtnCancel = () => {
        this.setState({
            showDeleteConfirmation: false
        })
    }

    render(){
        const {item, index, editId} = this.props;
        const {showDeleteConfirmation} = this.state;
        return (
            <tr className="discount-item">
                <td>{index + 1}</td>
                <td>{item.code}</td>
                <td>{item.start_date ? item.start_date : 'N/A'}</td>
                <td>{item.end_date ? item.end_date : 'N/A'}</td>
                <td style={item.max_uses === 0 ? {color: "#a92323"} : {}}>{item.max_uses !== null ? item.max_uses : 'Unlimited'}</td>
                <td className="btn-group">
                    <div>
                        <button className={`${editId !== null && editId === index ? 'editing' : ''}`} onClick={() => this.props.editItem(index)} disabled={editId !== null && editId === index}>EDIT</button>
                    </div>
                    <div>
                        <button onClick={() => this.deleteBtnClick()} disabled={showDeleteConfirmation}>
                            DELETE
                        </button>
                        {showDeleteConfirmation && 
                                <div className="confirm-tooltip" ref={this.setWrapperRef}>
                                    Delete "{item.code}"
                                    <div className="confirm-tooltip-btns">
                                        <button onClick={() => this.deleteConfirmBtnYes()}>Yes</button>
                                        <button onClick={() => this.deleteCofirmBtnCancel()}>Cancel</button>
                                    </div>
                                </div>
                            }
                    </div>
                </td>
            </tr>
        )
    }
}

export default BuyXGetYItem;


// WEBPACK FOOTER //
// ./src/components/admin/discounts/BuyXGetYItem.js